<template><section><h3>图表介绍</h3>
<p>Area Chart, 面积图。</p>
<h3>attrs</h3>
<p>attrs 包含若干布局属性，将这些属性放入 Object 对象传入组件</p>
<table>
<thead>
<tr>
<th>属性名</th>
<th>类型</th>
<th>默认值</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>clientRect</td>
<td>Object</td>
<td>{top,right,bottom,left,width,height}</td>
<td>设置了 width,heigh,优先与 bottom,right</td>
</tr>
<tr>
<td>smooth</td>
<td>Boolean</td>
<td>false</td>
<td>曲线是否平滑</td>
</tr>
<tr>
<td>axisGap</td>
<td>Boolean</td>
<td>false</td>
<td>开始绘图区域与坐标轴是否有间隙</td>
</tr>
<tr>
<td>splitNumber</td>
<td>Number</td>
<td>0</td>
<td>坐标轴的分割段数，用来计算面积图的最大高度，在设置坐标轴的 splitNumber 属性时同步加上</td>
</tr>
<tr>
<td>strack</td>
<td>Boolean</td>
<td>true</td>
<td>是否堆叠</td>
</tr>
</tbody>
</table>
<h3>style 属性</h3>
<pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> area = <span class="hljs-keyword">new</span> Area({ <span class="hljs-attr">smooth</span>: <span class="hljs-literal">true</span> })
area.style(<span class="hljs-string">'area'</span>, <span class="hljs-function"><span class="hljs-keyword">function</span>(<span class="hljs-params">attrs, data, i</span>) </span>{
  <span class="hljs-keyword">if</span> (i === <span class="hljs-number">0</span>) {
    <span class="hljs-keyword">return</span> { <span class="hljs-attr">fillColor</span>: <span class="hljs-string">'transparent'</span> }
  }
})
</code></pre>
<p>组件中可以自定义 css 属性的元素如下表：</p>
<table>
<thead>
<tr>
<th>名称</th>
<th>基础类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>guideline</td>
<td>线</td>
<td>指导线样式</td>
</tr>
<tr>
<td>line</td>
<td>线</td>
<td>线条样式</td>
</tr>
<tr>
<td>area</td>
<td>面</td>
<td>面积样式设置 （Polygon）</td>
</tr>
<tr>
<td>point</td>
<td>面</td>
<td>线条上标记点样式</td>
</tr>
<tr>
<td>point:hover</td>
<td>面</td>
<td>hover 时线条上标记点样式</td>
</tr>
</tbody>
</table>
</section></template><script>export default {components:{}}</script>